<template>
    <div class="card-container">
        <ListHeader title="三级维度指标">
            <template slot="right">
                <ActionButton />
            </template>
        </ListHeader>
        <div class="content">
            <div class="score">
                <Score />
            </div>
            <div class="divider"></div>
            <div class="chart-container">
                <div ref="lineChart" class="line-chart"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';
import ActionButton from './ActionButton.vue';

export default {
    name: 'ReportStyle3',
    components: {
        ListHeader,
        Score,
        ActionButton,
    },
    data() {
        return {
            lineChart: null,
            chartData: {
                categories: ['导入', '讲解', '互动', '练习', '总结'],
                values: [85, 92, 88, 90, 95]
            }
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.resizeChart);
    },
    beforeDestroy() {
        if (this.lineChart) {
            this.lineChart.dispose();
        }
        window.removeEventListener('resize', this.resizeChart);
    },
    methods: {
        initChart() {
            this.lineChart = echarts.init(this.$refs.lineChart);
            const option = {
                grid: {
                    left: '10%',
                    right: '10%',
                    top: '20%',
                    bottom: '20%'
                },
                xAxis: {
                    type: 'category',
                    data: this.chartData.categories,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(123, 168, 208, 0.5)'
                        }
                    },
                    axisLabel: {
                        color: 'rgba(123, 168, 208, 0.8)',
                        fontSize: 12
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    max: 100,
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(123, 168, 208, 0.2)'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(123, 168, 208, 0.5)'
                        }
                    },
                    axisLabel: {
                        color: 'rgba(123, 168, 208, 0.8)',
                        fontSize: 12
                    }
                },
                series: [{
                    data: this.chartData.values,
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 6,
                    lineStyle: {
                        color: '#0585F7',
                        width: 3
                    },
                    itemStyle: {
                        color: '#0585F7',
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: 'rgba(5, 133, 247, 0.5)'
                        }, {
                            offset: 1,
                            color: 'rgba(5, 133, 247, 0.1)'
                        }])
                    }
                }]
            };
            this.lineChart.setOption(option);
        },
        resizeChart() {
            if (this.lineChart) {
                this.lineChart.resize();
            }
        }
    }
}
</script>
<style lang="less" scoped>
.card-container {
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    .content {
        height: 220px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 0 20px;

        .score {
            /* 固定宽度 */
            width: 124px;
            height: 108px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .divider {
            width: 1px;
            height: 180px;
            background: #043B6A;
            margin: 0 20px;
        }

        .chart-container {
            /* 剩余空间都给图表 */
            flex: 1;
            height: 180px;
            min-width: 200px;
        }

        .line-chart {
            width: 100%;
            height: 100%;
        }
    }
}
</style>